import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  box_notification_body: {
    "& nth:last-child": {
      border: 0,
    },
    borderBottom: `solid 1px ${palette.grey["200"]}`,
    width: spacing(50),
  },
}));
